{
  "level": "bs01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs01",
    "objects": "AREAS.E3:bs01.e3",
    "mesh": "TREES.E3:bs01.e3"
  },
  "spawn_point": {
    "position": [
      -3833.493707011371,
      -4523.28413992923,
      1006.623779296875
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3833.493707011371,
      -4423.28413992923,
      1006.623779296875
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4133.0,
      -4814.63330078125,
      982.623779296875
    ],
    "bbox_max": [
      -3543.705810546875,
      -3881.7685546875,
      1032.62548828125
    ],
    "vertex_count": 393,
    "vertices": [
      [
        -3784.999755859375,
        -4369.7685546875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4549.7685546875,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4326.259765625,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4326.25927734375,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4326.25927734375,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4637.44189453125,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4637.44140625,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4637.44189453125,
        1032.5999755859375
      ],
      [
        -3972.0,
        -4670.5830078125,
        1032.61474609375
      ],
      [
        -4086.999755859375,
        -4449.7685546875,
        1032.623779296875
      ],
      [
        -4108.0,
        -4449.7685546875,
        1032.62548828125
      ],
      [
        -4086.999755859375,
        -4449.7685546875,
        1032.623779296875
      ],
      [
        -4108.0,
        -4449.7685546875,
        1032.62548828125
      ],
      [
        -4086.999755859375,
        -4489.7685546875,
        1032.623779296875
      ],
      [
        -4108.0,
        -4489.7685546875,
        1032.62548828125
      ],
      [
        -4086.999755859375,
        -4489.7685546875,
        1032.623779296875
      ],
      [
        -4108.0,
        -4489.7685546875,
        1032.62548828125
      ],
      [
        -3887.814208984375,
        -4754.76904296875,
        1032.6080322265625
      ],
      [
        -3924.365478515625,
        -4707.13427734375,
        1032.6109619140625
      ],
      [
        -3864.8369140625,
        -4810.24072265625,
        1032.6063232421875
      ],
      [
        -3887.814208984375,
        -4754.76904296875,
        1032.6080322265625
      ],
      [
        -3924.365478515625,
        -4707.13427734375,
        1032.6109619140625
      ],
      [
        -3972.0,
        -4670.5830078125,
        1032.61474609375
      ],
      [
        -3973.513671875,
        -4673.205078125,
        1032.6148681640625
      ],
      [
        -3870.679931640625,
        -4811.806640625,
        1032.606689453125
      ],
      [
        -3893.052978515625,
        -4757.79345703125,
        1032.6085205078125
      ],
      [
        -3893.052978515625,
        -4757.79345703125,
        1032.6085205078125
      ],
      [
        -3928.643310546875,
        -4711.412109375,
        1032.611328125
      ],
      [
        -3928.643310546875,
        -4711.412109375,
        1032.611328125
      ],
      [
        -3975.025146484375,
        -4675.82275390625,
        1032.614990234375
      ],
      [
        -3975.025146484375,
        -4675.82275390625,
        1032.614990234375
      ],
      [
        -3978.974853515625,
        -4682.6640625,
        1032.615234375
      ],
      [
        -3978.974853515625,
        -4682.6640625,
        1032.615234375
      ],
      [
        -3934.229736328125,
        -4716.9990234375,
        1032.6116943359375
      ],
      [
        -3881.230224609375,
        -4814.63330078125,
        1032.6075439453125
      ],
      [
        -3902.511962890625,
        -4763.25439453125,
        1032.6092529296875
      ],
      [
        -3936.366455078125,
        -4719.1357421875,
        1032.6119384765625
      ],
      [
        -3980.486328125,
        -4685.28173828125,
        1032.6153564453125
      ],
      [
        -3980.486328125,
        -4685.28173828125,
        1032.6153564453125
      ],
      [
        -3902.511962890625,
        -4763.25439453125,
        1032.6092529296875
      ],
      [
        -3936.366455078125,
        -4719.1357421875,
        1032.6119384765625
      ],
      [
        -3982.0,
        -4687.90380859375,
        1032.615478515625
      ],
      [
        -3938.507568359375,
        -4721.2763671875,
        1032.612060546875
      ],
      [
        -3982.0,
        -4687.90380859375,
        1032.615478515625
      ],
      [
        -3569.063232421875,
        -4488.107421875,
        1032.5830078125
      ],
      [
        -3569.2177734375,
        -4488.107421875,
        1032.5830078125
      ],
      [
        -3569.2177734375,
        -4488.107421875,
        1032.5830078125
      ],
      [
        -3569.063232421875,
        -4472.7685546875,
        1032.5830078125
      ],
      [
        -3569.2177734375,
        -4472.7685546875,
        1032.5830078125
      ],
      [
        -3569.2177734375,
        -4472.7685546875,
        1032.5830078125
      ],
      [
        -3561.76171875,
        -4454.267578125,
        1032.5823974609375
      ],
      [
        -3617.999755859375,
        -4401.0654296875,
        1032.5867919921875
      ],
      [
        -3684.999755859375,
        -4337.68212890625,
        1032.592041015625
      ],
      [
        -3617.999755859375,
        -4401.0654296875,
        1032.5867919921875
      ],
      [
        -3660.981689453125,
        -4289.7998046875,
        1032.5902099609375
      ],
      [
        -3588.8857421875,
        -4322.6318359375,
        1032.58447265625
      ],
      [
        -3684.999755859375,
        -4337.68212890625,
        1032.592041015625
      ],
      [
        -3624.999755859375,
        -4326.27099609375,
        1032.58740234375
      ],
      [
        -3632.999755859375,
        -4326.27001953125,
        1032.5880126953125
      ],
      [
        -3667.999755859375,
        -4318.76806640625,
        1032.5906982421875
      ],
      [
        -3675.999755859375,
        -4318.76708984375,
        1032.5914306640625
      ],
      [
        -3632.999755859375,
        -4326.27001953125,
        1032.5880126953125
      ],
      [
        -3632.999755859375,
        -4321.85595703125,
        1032.5880126953125
      ],
      [
        -3684.999755859375,
        -4622.85546875,
        1032.592041015625
      ],
      [
        -3561.761474609375,
        -4506.26953125,
        1032.5823974609375
      ],
      [
        -3617.999755859375,
        -4559.47216796875,
        1032.5867919921875
      ],
      [
        -3617.999755859375,
        -4559.47216796875,
        1032.5867919921875
      ],
      [
        -3684.999755859375,
        -4622.85546875,
        1032.592041015625
      ],
      [
        -3660.981689453125,
        -4675.39990234375,
        1032.5902099609375
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1032.58447265625
      ],
      [
        -3543.705810546875,
        -4602.70458984375,
        1032.5809326171875
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1032.58447265625
      ],
      [
        -3632.999755859375,
        -4637.43310546875,
        1032.5880126953125
      ],
      [
        -3624.999755859375,
        -4637.4326171875,
        1032.58740234375
      ],
      [
        -3675.999755859375,
        -4647.3310546875,
        1032.5914306640625
      ],
      [
        -3667.999755859375,
        -4647.33056640625,
        1032.5906982421875
      ],
      [
        -3632.999755859375,
        -4641.00732421875,
        1032.5880126953125
      ],
      [
        -3632.999755859375,
        -4637.43310546875,
        1032.5880126953125
      ],
      [
        -3561.761474609375,
        -4506.26953125,
        1032.5823974609375
      ],
      [
        -3569.063232421875,
        -4488.107421875,
        1032.5830078125
      ],
      [
        -4108.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      [
        -4108.0,
        -4659.76904296875,
        1032.6239013671875
      ],
      [
        -4108.0,
        -4645.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4645.76904296875,
        1032.6239013671875
      ],
      [
        -4108.0,
        -4643.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4645.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4643.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4642.7998046875,
        1032.6239013671875
      ],
      [
        -4128.0,
        -4645.7685546875,
        1032.6239013671875
      ],
      [
        -4128.0,
        -4642.7998046875,
        1032.6239013671875
      ],
      [
        -4133.0,
        -4643.2685546875,
        1029.6239013671875
      ],
      [
        -4133.0,
        -4645.2685546875,
        1029.6239013671875
      ],
      [
        -4133.0,
        -4643.43603515625,
        1018.6239013671875
      ],
      [
        -4133.0,
        -4645.2685546875,
        1029.6239013671875
      ],
      [
        -4128.0,
        -4642.935546875,
        1015.6239013671875
      ],
      [
        -4133.0,
        -4643.43603515625,
        1018.6239013671875
      ],
      [
        -4108.0,
        -4654.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4656.76904296875,
        1032.6239013671875
      ],
      [
        -4108.0,
        -4653.76904296875,
        1032.6239013671875
      ],
      [
        -4108.0,
        -4654.26904296875,
        1029.6239013671875
      ],
      [
        -4128.0,
        -4656.76904296875,
        1032.6239013671875
      ],
      [
        -4128.0,
        -4653.76904296875,
        1032.6239013671875
      ],
      [
        -4133.0,
        -4654.26904296875,
        1029.6239013671875
      ],
      [
        -4133.0,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -3735.24462890625,
        -4670.3876953125,
        1027.623779296875
      ],
      [
        -3684.999755859375,
        -4622.85546875,
        1027.623779296875
      ],
      [
        -3597.171875,
        -4539.7685546875,
        1032.585205078125
      ],
      [
        -3617.999755859375,
        -4559.47216796875,
        1027.623779296875
      ],
      [
        -3597.171875,
        -4539.7685546875,
        1027.623779296875
      ],
      [
        -3660.981689453125,
        -4675.39990234375,
        1027.623779296875
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1027.623779296875
      ],
      [
        -3864.8369140625,
        -4810.24072265625,
        1027.623779296875
      ],
      [
        -3869.97216796875,
        -4797.8427734375,
        1027.623779296875
      ],
      [
        -3869.97216796875,
        -4797.8427734375,
        1032.606689453125
      ],
      [
        -3872.694091796875,
        -4800.41796875,
        1029.6239013671875
      ],
      [
        -3874.24951171875,
        -4801.88916015625,
        1029.6239013671875
      ],
      [
        -3874.24951171875,
        -4801.88916015625,
        1029.6239013671875
      ],
      [
        -3874.63623046875,
        -4802.25537109375,
        1032.6070556640625
      ],
      [
        -3882.670654296875,
        -4809.85595703125,
        1029.6239013671875
      ],
      [
        -3883.057373046875,
        -4810.22216796875,
        1032.607666015625
      ],
      [
        -3543.705810546875,
        -4602.70458984375,
        1027.623779296875
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4643.12109375,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4643.12109375,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4633.88427734375,
        1027.623779296875
      ],
      [
        -3624.999755859375,
        -4633.88427734375,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4637.45849609375,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4633.88427734375,
        1027.623779296875
      ],
      [
        -4027.4716796875,
        -4647.60595703125,
        1027.623779296875
      ],
      [
        -4086.999755859375,
        -4639.7685546875,
        1027.623779296875
      ],
      [
        -3784.999755859375,
        -4539.7685546875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4549.7685546875,
        1027.623779296875
      ],
      [
        -3784.999755859375,
        -4539.7685546875,
        1027.623779296875
      ],
      [
        -3972.0,
        -4670.5830078125,
        1027.623779296875
      ],
      [
        -4027.4716796875,
        -4647.60595703125,
        1027.623779296875
      ],
      [
        -3924.365478515625,
        -4707.13427734375,
        1027.623779296875
      ],
      [
        -3972.0,
        -4670.5830078125,
        1027.623779296875
      ],
      [
        -3887.814208984375,
        -4754.76904296875,
        1027.623779296875
      ],
      [
        -3924.365478515625,
        -4707.13427734375,
        1027.623779296875
      ],
      [
        -4086.999755859375,
        -4643.2734375,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4645.26904296875,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4645.26904296875,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4644.2763671875,
        1029.6239013671875
      ],
      [
        -4021.22314453125,
        -4653.98291015625,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4643.2734375,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4644.2763671875,
        1029.6239013671875
      ],
      [
        -3967.63525390625,
        -4678.34423828125,
        1029.6239013671875
      ],
      [
        -3922.16015625,
        -4715.75830078125,
        1029.6239013671875
      ],
      [
        -3887.9150390625,
        -4763.67138671875,
        1029.6239013671875
      ],
      [
        -3887.814208984375,
        -4754.76904296875,
        1029.6239013671875
      ],
      [
        -3878.947021484375,
        -4776.17626953125,
        1032.607421875
      ],
      [
        -3879.682373046875,
        -4774.400390625,
        1029.6239013671875
      ],
      [
        -3880.175537109375,
        -4773.2099609375,
        1027.623779296875
      ],
      [
        -3887.814208984375,
        -4754.76904296875,
        1027.623779296875
      ],
      [
        -4086.999755859375,
        -4654.2734375,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4655.27294921875,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4654.2734375,
        1029.6239013671875
      ],
      [
        -4086.999755859375,
        -4655.27294921875,
        1029.6239013671875
      ],
      [
        -4024.085693359375,
        -4664.51806640625,
        1029.6239013671875
      ],
      [
        -3973.09619140625,
        -4687.80322265625,
        1029.6239013671875
      ],
      [
        -3929.881103515625,
        -4723.484375,
        1029.6239013671875
      ],
      [
        -4032.64794921875,
        -4666.9248046875,
        1027.623779296875
      ],
      [
        -4087.0,
        -4659.76904296875,
        1027.623779296875
      ],
      [
        -3982.0,
        -4687.90380859375,
        1027.623779296875
      ],
      [
        -4032.64794921875,
        -4666.9248046875,
        1027.623779296875
      ],
      [
        -3876.607177734375,
        -4796.197265625,
        1029.6239013671875
      ],
      [
        -3873.0849609375,
        -4800.78759765625,
        1029.6239013671875
      ],
      [
        -3876.607177734375,
        -4796.197265625,
        1029.6239013671875
      ],
      [
        -3877.0419921875,
        -4796.447265625,
        1032.6072998046875
      ],
      [
        -3879.682373046875,
        -4774.400390625,
        1029.6239013671875
      ],
      [
        -3869.97216796875,
        -4797.8427734375,
        1029.6239013671875
      ],
      [
        -3938.507568359375,
        -4721.2763671875,
        1027.623779296875
      ],
      [
        -3982.0,
        -4687.90380859375,
        1027.623779296875
      ],
      [
        -3660.981689453125,
        -4675.39990234375,
        1015.623779296875
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1015.623779296875
      ],
      [
        -3892.340087890625,
        -4748.87060546875,
        1015.6239013671875
      ],
      [
        -3892.340087890625,
        -4748.87060546875,
        1027.623779296875
      ],
      [
        -3735.24462890625,
        -4670.3876953125,
        1015.623779296875
      ],
      [
        -3684.999755859375,
        -4622.85546875,
        1015.623779296875
      ],
      [
        -3617.999755859375,
        -4559.47216796875,
        1015.623779296875
      ],
      [
        -3597.171875,
        -4539.7685546875,
        1015.623779296875
      ],
      [
        -3543.705810546875,
        -4602.70458984375,
        1015.623779296875
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1015.623779296875
      ],
      [
        -3617.999755859375,
        -4559.47216796875,
        1015.623779296875
      ],
      [
        -3617.999755859375,
        -4586.748046875,
        1015.623779296875
      ],
      [
        -3675.999755859375,
        -4632.95068359375,
        1015.623779296875
      ],
      [
        -3667.999755859375,
        -4632.95068359375,
        1015.623779296875
      ],
      [
        -3632.999755859375,
        -4625.30517578125,
        1015.623779296875
      ],
      [
        -3624.999755859375,
        -4625.30517578125,
        1015.623779296875
      ],
      [
        -3632.999755859375,
        -4628.87939453125,
        1015.623779296875
      ],
      [
        -3632.999755859375,
        -4625.30517578125,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4549.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4539.7685546875,
        1015.623779296875
      ],
      [
        -3871.681640625,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3871.681640625,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3699.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3569.063232421875,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3659.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -3699.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -3659.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -3569.063232421875,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -4076.999755859375,
        -4472.7685546875,
        1032.623779296875
      ],
      [
        -4076.999755859375,
        -4488.107421875,
        1032.623779296875
      ],
      [
        -4076.999755859375,
        -4488.107421875,
        1022.623779296875
      ],
      [
        -4076.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      [
        -3784.999755859375,
        -4472.7685546875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4488.107421875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4488.107421875,
        1022.623779296875
      ],
      [
        -3784.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      [
        -4118.0,
        -4488.107421875,
        1022.623779296875
      ],
      [
        -4118.0,
        -4488.107421875,
        1032.623779296875
      ],
      [
        -4118.0,
        -4472.7685546875,
        1032.623779296875
      ],
      [
        -4118.0,
        -4472.7685546875,
        1022.623779296875
      ],
      [
        -3659.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -3699.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -3699.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -3659.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      [
        -3659.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      [
        -3659.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3659.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -4118.0,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -4118.0,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -4118.0,
        -4480.7685546875,
        1022.623779296875
      ],
      [
        -4076.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -4076.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -4076.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      [
        -3784.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -3659.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -4076.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -4118.0,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4439.7685546875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      [
        -3561.76171875,
        -4454.267578125,
        1015.623779296875
      ],
      [
        -3577.087890625,
        -4439.7685546875,
        1015.623779296875
      ],
      [
        -3577.088134765625,
        -4439.7685546875,
        1032.5836181640625
      ],
      [
        -3564.375,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3569.063232421875,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3564.375,
        -4499.7685546875,
        1032.5826416015625
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4495.36865234375,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3561.761474609375,
        -4506.26953125,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4535.36865234375,
        1015.623779296875
      ],
      [
        -3561.761474609375,
        -4506.26953125,
        1015.623779296875
      ],
      [
        -4087.0,
        -3920.0,
        1015.623779296875
      ],
      [
        -4087.0,
        -3920.0,
        1015.623779296875
      ],
      [
        -3619.3701171875,
        -4399.7685546875,
        1027.623779296875
      ],
      [
        -3619.37060546875,
        -4399.7685546875,
        1032.5869140625
      ],
      [
        -3619.3701171875,
        -4399.7685546875,
        1027.623779296875
      ],
      [
        -3617.999755859375,
        -4399.7685546875,
        1027.623779296875
      ],
      [
        -3660.981689453125,
        -4289.7998046875,
        1027.623779296875
      ],
      [
        -3588.8857421875,
        -4322.6318359375,
        1027.623779296875
      ],
      [
        -4086.999755859375,
        -3881.7685546875,
        1032.623779296875
      ],
      [
        -4077.0,
        -3902.7685546875,
        1027.623779296875
      ],
      [
        -4077.0,
        -3881.7685546875,
        1027.623779296875
      ],
      [
        -4086.999755859375,
        -3881.7685546875,
        1032.623779296875
      ],
      [
        -4077.0,
        -3881.7685546875,
        1027.623779296875
      ],
      [
        -4086.999755859375,
        -3881.7685546875,
        1027.623779296875
      ],
      [
        -4086.999755859375,
        -3902.7685546875,
        1027.623779296875
      ],
      [
        -4077.0,
        -3902.7685546875,
        1027.623779296875
      ],
      [
        -3684.999755859375,
        -4337.68212890625,
        1027.623779296875
      ],
      [
        -3728.17138671875,
        -4296.7978515625,
        1027.623779296875
      ],
      [
        -3667.999755859375,
        -4323.1533203125,
        1027.623779296875
      ],
      [
        -3675.999755859375,
        -4323.15283203125,
        1027.623779296875
      ],
      [
        -3624.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4330.65283203125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4330.65283203125,
        1027.623779296875
      ],
      [
        -3632.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      [
        -3660.981689453125,
        -4289.7998046875,
        1015.623779296875
      ],
      [
        -3588.8857421875,
        -4322.6318359375,
        1015.623779296875
      ],
      [
        -4086.999755859375,
        -3881.7685546875,
        1015.623779296875
      ],
      [
        -3684.999755859375,
        -4337.68212890625,
        1015.623779296875
      ],
      [
        -3728.171142578125,
        -4296.7978515625,
        1015.623779296875
      ],
      [
        -3624.999755859375,
        -4341.24755859375,
        1015.623779296875
      ],
      [
        -3632.999755859375,
        -4341.24755859375,
        1015.623779296875
      ],
      [
        -3667.999755859375,
        -4333.74755859375,
        1015.623779296875
      ],
      [
        -3675.999755859375,
        -4333.74755859375,
        1015.623779296875
      ],
      [
        -3632.999755859375,
        -4341.24755859375,
        1015.623779296875
      ],
      [
        -3632.999755859375,
        -4336.8330078125,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4369.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4399.7685546875,
        1032.5999755859375
      ],
      [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      [
        -4108.0,
        -3920.0,
        1015.623779296875
      ],
      [
        -4108.0,
        -3920.0,
        1015.623779296875
      ],
      [
        -4108.0,
        -3881.7685546875,
        1032.623779296875
      ],
      [
        -4108.0,
        -3881.7685546875,
        1032.623779296875
      ],
      [
        -4108.0,
        -3881.7685546875,
        1015.623779296875
      ],
      [
        -3617.999755859375,
        -4401.06494140625,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      [
        -3660.981689453125,
        -4289.7998046875,
        1012.623779296875
      ],
      [
        -3588.8857421875,
        -4322.6318359375,
        1012.623779296875
      ],
      [
        -3684.999755859375,
        -4337.68212890625,
        1012.623779296875
      ],
      [
        -3728.171142578125,
        -4296.7978515625,
        1012.623779296875
      ],
      [
        -3632.999755859375,
        -4342.21875,
        1012.623779296875
      ],
      [
        -3632.999755859375,
        -4339.48193359375,
        1012.623779296875
      ],
      [
        -4086.999755859375,
        -3881.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4399.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      [
        -4108.0,
        -3881.7685546875,
        1015.623779296875
      ],
      [
        -3660.981689453125,
        -4675.39990234375,
        1012.623779296875
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1012.623779296875
      ],
      [
        -3735.24462890625,
        -4670.3876953125,
        1012.623779296875
      ],
      [
        -3684.999755859375,
        -4622.85546875,
        1012.623779296875
      ],
      [
        -3617.999755859375,
        -4559.47216796875,
        1012.623779296875
      ],
      [
        -3597.171875,
        -4539.7685546875,
        1002.5999755859375
      ],
      [
        -3597.171875,
        -4539.7685546875,
        1012.623779296875
      ],
      [
        -3543.705810546875,
        -4602.70458984375,
        1012.623779296875
      ],
      [
        -3588.8857421875,
        -4652.5048828125,
        1012.623779296875
      ],
      [
        -3617.999755859375,
        -4559.47216796875,
        1012.623779296875
      ],
      [
        -3617.999755859375,
        -4586.748046875,
        1012.623779296875
      ],
      [
        -3632.999755859375,
        -4626.73486328125,
        1012.623779296875
      ],
      [
        -3632.999755859375,
        -4624.5185546875,
        1012.623779296875
      ],
      [
        -3892.340087890625,
        -4748.87060546875,
        1012.6239013671875
      ],
      [
        -3892.340087890625,
        -4748.87060546875,
        1015.6239013671875
      ],
      [
        -3597.171875,
        -4539.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4539.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4539.7685546875,
        1015.623779296875
      ],
      [
        -3919.14404296875,
        -4713.93896484375,
        1012.6239013671875
      ],
      [
        -3919.14404296875,
        -4713.93896484375,
        1015.6239013671875
      ],
      [
        -4108.0,
        -4659.76904296875,
        1012.6239013671875
      ],
      [
        -4108.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      [
        -3836.999755859375,
        -4472.7685546875,
        982.623779296875
      ],
      [
        -3836.999755859375,
        -4488.107421875,
        982.623779296875
      ],
      [
        -3886.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -3886.999755859375,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4086.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4086.999755859375,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4076.999755859375,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4076.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4118.0,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4118.0,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4108.0,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4108.0,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4108.0,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4108.0,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4086.999755859375,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4086.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4076.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4076.999755859375,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4076.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -4076.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -4118.0,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -4118.0,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -4118.0,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -4118.0,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4480.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      [
        -3659.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      [
        -3659.999755859375,
        -4480.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4472.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      [
        -3836.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      [
        -3886.999755859375,
        -4439.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4439.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      [
        -3577.088134765625,
        -4439.7685546875,
        1002.5999755859375
      ],
      [
        -3577.087890625,
        -4439.7685546875,
        1015.623779296875
      ],
      [
        -3836.999755859375,
        -4499.7685546875,
        982.623779296875
      ],
      [
        -3886.999755859375,
        -4499.7685546875,
        1012.623779296875
      ],
      [
        -3564.375,
        -4499.7685546875,
        1002.5999755859375
      ],
      [
        -3564.375,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1000.623779296875
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1012.623779296875
      ],
      [
        -3784.999755859375,
        -4499.7685546875,
        1015.623779296875
      ],
      [
        -3561.761474609375,
        -4506.26953125,
        1012.623779296875
      ],
      [
        -3597.171875,
        -4539.7685546875,
        1012.623779296875
      ],
      [
        -3561.761474609375,
        -4506.26953125,
        1012.623779296875
      ],
      [
        -3564.375,
        -4499.7685546875,
        1012.623779296875
      ],
      [
        -3617.999755859375,
        -4401.06494140625,
        1012.623779296875
      ],
      [
        -3577.087890625,
        -4439.7685546875,
        1012.623779296875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -7.882023783167824e-05,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.3016357421875,
      "bbox_min": [
        -4164.0,
        -4815.4169921875,
        1015.623779296875
      ],
      "bbox_max": [
        -3515.0,
        -3881.7685546875,
        1059.7738037109375
      ],
      "face_count": 20
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.5999755859375,
      "bbox_min": [
        -4118.0,
        -4815.4169921875,
        1032.5809326171875
      ],
      "bbox_max": [
        -3515.0,
        -4002.7685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4118.0,
        -4815.4169921875,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4002.7685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4294.7685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4326.25927734375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3632.999755859375,
        -4294.7685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4326.25927734375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3632.999755859375,
        -4302.2685546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3632.999755859375,
        -4637.44189453125,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826834261417389,
        -0.9238795042037964,
        0.0
      ],
      "plane_d": -5835.07470703125,
      "bbox_min": [
        -4118.0,
        -4815.4169921875,
        1032.6063232421875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1042.623779296875,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -2152.698974609375,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3642.041259765625,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2409.21533203125,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4222.7685546875,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4112.7685546875,
      "bbox_min": [
        -4118.0,
        -4122.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4002.7685546875,
      "bbox_min": [
        -4118.0,
        -4012.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.7685546875,
      "bbox_min": [
        -4118.0,
        -4012.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4012.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4122.7685546875,
      "bbox_min": [
        -4118.0,
        -4122.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4122.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4332.7685546875,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4232.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4232.7685546875,
      "bbox_min": [
        -4118.0,
        -4232.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4232.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4342.7685546875,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4342.7685546875,
        1042.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3911.992431640625,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4439.7685546875,
        1042.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4108.0,
        -4499.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4489.7685546875,
        1042.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087611317634583,
        -0.7933535575866699,
        0.0
      ],
      "plane_d": -6123.4228515625,
      "bbox_min": [
        -4032.64794921875,
        -4815.4169921875,
        1032.606689453125
      ],
      "bbox_max": [
        -3870.679931640625,
        -4647.60595703125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -4032.64794921875,
        -4815.4169921875,
        1032.606689453125
      ],
      "bbox_max": [
        -3870.679931640625,
        -4647.60595703125,
        1032.6239013671875
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.37747666239738464,
        0.9113092422485352,
        -0.16439828276634216
      ],
      "plane_d": 5928.404296875,
      "bbox_min": [
        -4032.64794921875,
        -4814.6337890625,
        1032.606689453125
      ],
      "bbox_max": [
        -3870.679931640625,
        -4650.52880859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7825579643249512,
        -0.6004788279533386,
        -0.1644025295972824
      ],
      "plane_d": -5733.72998046875,
      "bbox_min": [
        -4032.64794921875,
        -4814.6337890625,
        1032.6075439453125
      ],
      "bbox_max": [
        -3881.230224609375,
        -4653.45166015625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6004782915115356,
        -0.7825585007667542,
        -0.16440211236476898
      ],
      "plane_d": -5876.2568359375,
      "bbox_min": [
        -4032.64794921875,
        -4814.6337890625,
        1032.6075439453125
      ],
      "bbox_max": [
        -3881.230224609375,
        -4653.45166015625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3774767220020294,
        -0.9113094210624695,
        -0.16439735889434814
      ],
      "plane_d": -5591.841796875,
      "bbox_min": [
        -4032.64794921875,
        -4814.6337890625,
        1032.6075439453125
      ],
      "bbox_max": [
        -3881.230224609375,
        -4653.45166015625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9113102555274963,
        -0.3774770200252533,
        -0.16439183056354523
      ],
      "plane_d": -5184.666015625,
      "bbox_min": [
        -4032.64794921875,
        -4814.6337890625,
        1032.6075439453125
      ],
      "bbox_max": [
        -3881.230224609375,
        -4664.001953125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6004780530929565,
        -0.7825586795806885,
        -0.16440211236476898
      ],
      "plane_d": -5886.9384765625,
      "bbox_min": [
        -4032.64794921875,
        -4763.255859375,
        1032.6092529296875
      ],
      "bbox_max": [
        -3902.511962890625,
        -4664.001953125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.377476304769516,
        -0.9113095998764038,
        -0.16439735889434814
      ],
      "plane_d": -5602.5224609375,
      "bbox_min": [
        -4032.64794921875,
        -4763.255859375,
        1032.6092529296875
      ],
      "bbox_max": [
        -3902.511962890625,
        -4664.001953125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268324732780457,
        0.9238796234130859,
        0.0
      ],
      "plane_d": 5854.9033203125,
      "bbox_min": [
        -4032.64794921875,
        -4721.2763671875,
        1032.612060546875
      ],
      "bbox_max": [
        -3938.507568359375,
        -4666.9248046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087613701820374,
        0.7933533787727356,
        0.0
      ],
      "plane_d": 6143.251953125,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1032.612060546875
      ],
      "bbox_max": [
        -3938.507568359375,
        -4687.90380859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4488.107421875,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5809326171875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4472.7685546875,
      "bbox_min": [
        -3784.999755859375,
        -4472.7685546875,
        1032.5823974609375
      ],
      "bbox_max": [
        -3561.76171875,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6872280240058899,
        -0.7264418005943298,
        -7.128093420760706e-05
      ],
      "plane_d": -5683.43505859375,
      "bbox_min": [
        -3728.17138671875,
        -4454.267578125,
        1032.5823974609375
      ],
      "bbox_max": [
        -3561.76171875,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4144425392150879,
        -0.9100755453109741,
        -0.0
      ],
      "plane_d": -5421.30859375,
      "bbox_min": [
        -3728.17138671875,
        -4337.68212890625,
        1032.58447265625
      ],
      "bbox_max": [
        -3588.8857421875,
        -4289.7998046875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6876122951507568,
        -0.7260780930519104,
        0.0
      ],
      "plane_d": -5683.3466796875,
      "bbox_min": [
        -3728.17138671875,
        -4337.68212890625,
        1032.58740234375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4296.7978515625,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4326.27001953125,
        1032.5880126953125
      ],
      "bbox_max": [
        -3632.999755859375,
        -4318.759765625,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4326.27001953125,
        1032.5880126953125
      ],
      "bbox_max": [
        -3632.999755859375,
        -4321.84521484375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872280240058899,
        0.7264418005943298,
        0.0
      ],
      "plane_d": 825.80029296875,
      "bbox_min": [
        -3735.24462890625,
        -4675.39990234375,
        1032.5809326171875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7406286001205444,
        0.6719146966934204,
        0.0
      ],
      "plane_d": 468.054931640625,
      "bbox_min": [
        -3675.999755859375,
        -4652.5048828125,
        1032.5809326171875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4602.70458984375,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3675.999755859375,
        -4647.33837890625,
        1032.58740234375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.4326171875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4647.33837890625,
        1032.5880126953125
      ],
      "bbox_max": [
        -3632.999755859375,
        -4637.43310546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4641.01611328125,
        1032.5880126953125
      ],
      "bbox_max": [
        -3632.999755859375,
        -4637.43310546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9278250336647034,
        -0.37301579117774963,
        -0.0
      ],
      "plane_d": -4985.60107421875,
      "bbox_min": [
        -3569.063232421875,
        -4506.26953125,
        1032.5823974609375
      ],
      "bbox_max": [
        -3561.761474609375,
        -4488.107421875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4539.7685546875,
      "bbox_min": [
        -4164.0,
        -4814.63330078125,
        1015.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -3881.7685546875,
        1032.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4133.0,
        -4814.63330078125,
        1015.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4639.76904296875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4639.7685546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4659.76904296875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": -1854.73046875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.8574929237365723,
        0.0
      ],
      "plane_d": 6119.5576171875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4412.7958984375,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4133.0,
        -4645.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9879874587059021,
        -0.15453384816646576
      ],
      "plane_d": 4746.60302734375,
      "bbox_min": [
        -4133.0,
        -4645.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4645.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4125.0,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -2188.76171875,
      "bbox_min": [
        -4128.0,
        -4645.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4125.0,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4643.2685546875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4133.0,
      "bbox_min": [
        -4133.0,
        -4645.2685546875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4639.76904296875,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.0,
        0.8574929237365723
      ],
      "plane_d": 1252.9482421875,
      "bbox_min": [
        -4133.0,
        -4643.43603515625,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4639.76904296875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": -1863.305419921875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.8574929237365723,
        0.0
      ],
      "plane_d": 6110.982421875,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4133.0,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.0,
        0.8574929237365723
      ],
      "plane_d": 1252.9482421875,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4645.2685546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4649.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4423.646484375,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4649.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": 4760.2119140625,
      "bbox_min": [
        -4133.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4649.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4125.0,
        -4653.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -2188.761474609375,
      "bbox_min": [
        -4128.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4125.0,
        -4653.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4654.26904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4649.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4656.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4133.0,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4649.76904296875,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.0,
        0.8574929237365723
      ],
      "plane_d": 1252.9482421875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4649.76904296875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4086.999755859375,
      "bbox_min": [
        -4108.0,
        -4814.63330078125,
        1015.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -4087.0,
        -4814.63330078125,
        1015.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872280240058899,
        0.7264418005943298,
        0.0
      ],
      "plane_d": 825.80029296875,
      "bbox_min": [
        -4087.0,
        -4814.63330078125,
        1027.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1032.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": -5411.44384765625,
      "bbox_min": [
        -3883.057373046875,
        -4814.63330078125,
        1027.623779296875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4797.8427734375,
        1032.607666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3883.057373046875,
        -4814.63330078125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3868.24755859375,
        -4800.41796875,
        1032.607666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9113080501556396,
        -0.37747570872306824,
        -0.16440720856189728
      ],
      "plane_d": -5173.95361328125,
      "bbox_min": [
        -3883.057373046875,
        -4814.63330078125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3870.194091796875,
        -4801.88916015625,
        1032.607666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4647.3310546875,
        1027.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4633.88427734375,
        1032.5914306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4641.00732421875,
        1027.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4633.88427734375,
        1032.5880126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4641.00732421875,
        1027.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4633.88427734375,
        1032.5880126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13052630424499512,
        -0.9914448261260986,
        0.0
      ],
      "plane_d": -5133.53564453125,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4539.7685546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4549.7685546875,
        1027.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4539.7685546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826834261417389,
        -0.9238795042037964,
        0.0
      ],
      "plane_d": -5835.07470703125,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933534979820251,
        -0.6087612509727478,
        0.0
      ],
      "plane_d": -5978.9296875,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37747666239738464,
        0.9113092422485352,
        -0.16439828276634216
      ],
      "plane_d": 5928.404296875,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4086.999755859375,
        -4653.98291015625,
        1029.6239013671875
      ],
      "bbox_max": [
        -4021.22314453125,
        -4643.2734375,
        1029.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6004782915115356,
        -0.7825585007667542,
        -0.16440211236476898
      ],
      "plane_d": -5876.2568359375,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4653.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7825579643249512,
        -0.6004788279533386,
        -0.1644025295972824
      ],
      "plane_d": -5733.72998046875,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4653.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3928.2880859375,
        -4776.17626953125,
        1027.623779296875
      ],
      "bbox_max": [
        -3878.947021484375,
        -4711.05712890625,
        1032.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.127860426902771,
        0.9780719876289368,
        -0.16439850628376007
      ],
      "plane_d": 5244.048828125,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4653.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4086.999755859375,
        -4664.51806640625,
        1029.6239013671875
      ],
      "bbox_max": [
        -4024.085693359375,
        -4654.2734375,
        1029.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6004780530929565,
        -0.7825586795806885,
        -0.16440211236476898
      ],
      "plane_d": -5886.9384765625,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4659.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052625954151154,
        0.9914448261260986,
        0.0
      ],
      "plane_d": 5153.365234375,
      "bbox_min": [
        -4087.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4659.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268324732780457,
        0.9238796234130859,
        0.0
      ],
      "plane_d": 5854.9033203125,
      "bbox_min": [
        -4032.64794921875,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4666.9248046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3936.01123046875,
        -4800.78759765625,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4718.7802734375,
        1032.6085205078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9113080501556396,
        -0.37747570872306824,
        -0.16440720856189728
      ],
      "plane_d": -5173.95361328125,
      "bbox_min": [
        -3893.052978515625,
        -4797.8427734375,
        1029.6239013671875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4757.54296875,
        1032.6085205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": -5411.44384765625,
      "bbox_min": [
        -3879.682373046875,
        -4797.8427734375,
        1029.6239013671875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4774.400390625,
        1032.607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": -5411.44384765625,
      "bbox_min": [
        -3880.175537109375,
        -4797.8427734375,
        1027.623779296875
      ],
      "bbox_max": [
        -3869.97216796875,
        -4773.2099609375,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087613701820374,
        0.7933533787727356,
        0.0
      ],
      "plane_d": 6143.251953125,
      "bbox_min": [
        -3982.0,
        -4810.22216796875,
        1027.623779296875
      ],
      "bbox_max": [
        -3873.0849609375,
        -4687.90380859375,
        1032.615478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9113102555274963,
        -0.3774770200252533,
        -0.16439183056354523
      ],
      "plane_d": -5184.666015625,
      "bbox_min": [
        -3902.511962890625,
        -4810.22216796875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3873.0849609375,
        -4763.00390625,
        1032.6092529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1286684274673462,
        0.977958083152771,
        -0.16444607079029083
      ],
      "plane_d": 5236.14208984375,
      "bbox_min": [
        -4087.0,
        -4651.01611328125,
        1029.6239013671875
      ],
      "bbox_max": [
        -4028.2548828125,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3026682138442993,
        0.9530960321426392,
        0.0
      ],
      "plane_d": 3348.042236328125,
      "bbox_min": [
        -4087.0,
        -4810.24072265625,
        1015.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": -5411.44384765625,
      "bbox_min": [
        -3892.340087890625,
        -4810.24072265625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4748.87060546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933534979820251,
        -0.6087612509727478,
        0.0
      ],
      "plane_d": -5978.9296875,
      "bbox_min": [
        -3892.340087890625,
        -4754.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3887.814208984375,
        -4748.87060546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872249841690063,
        0.726444661617279,
        0.0
      ],
      "plane_d": 825.824951171875,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1027.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7406286001205444,
        0.6719146966934204,
        0.0
      ],
      "plane_d": 468.054931640625,
      "bbox_min": [
        -3675.999755859375,
        -4652.5048828125,
        1015.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4559.47216796875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3617.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4643.12109375,
        1015.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4559.47216796875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4643.12109375,
        1015.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4625.30517578125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4637.45849609375,
        1015.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4625.30517578125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4637.45849609375,
        1015.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4625.30517578125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826834261417389,
        -0.9238795042037964,
        0.0
      ],
      "plane_d": -5835.07470703125,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4539.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4549.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4539.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087611317634583,
        -0.7933535575866699,
        0.0
      ],
      "plane_d": -6123.4228515625,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3892.340087890625,
        -4639.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13052630424499512,
        -0.9914448261260986,
        0.0
      ],
      "plane_d": -5133.53564453125,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3892.340087890625,
        -4639.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087613701820374,
        0.7933533787727356,
        0.0
      ],
      "plane_d": 6143.251953125,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3892.340087890625,
        -4659.76904296875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052625954151154,
        0.9914448261260986,
        0.0
      ],
      "plane_d": 5153.365234375,
      "bbox_min": [
        -4087.0,
        -4687.90380859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3982.0,
        -4659.76904296875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268324732780457,
        0.9238796234130859,
        0.0
      ],
      "plane_d": 5854.9033203125,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3982.0,
        -4666.9248046875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933534979820251,
        -0.6087612509727478,
        0.0
      ],
      "plane_d": -5978.9296875,
      "bbox_min": [
        -3924.365478515625,
        -4748.87060546875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3892.340087890625,
        -4707.13427734375,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4412.7958984375,
      "bbox_min": [
        -4108.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9879874587059021,
        -0.15453384816646576
      ],
      "plane_d": 4746.60302734375,
      "bbox_min": [
        -4108.0,
        -4645.26904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4642.7998046875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4108.0,
        -4645.26904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4643.26904296875,
        1029.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": 4760.2119140625,
      "bbox_min": [
        -4108.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4653.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4423.646484375,
      "bbox_min": [
        -4108.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4654.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4108.0,
        -4656.26904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4654.26904296875,
        1029.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -4164.0,
        -4539.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -3881.7685546875,
        1032.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -4118.0,
        -4539.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4439.7685546875,
        1032.62548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4488.107421875,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1032.62548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4472.7685546875,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1032.62548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1022.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4472.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4488.107421875,
        1022.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4472.7685546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1022.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4472.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4480.7685546875,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1015.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1015.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3659.999755859375,
      "bbox_min": [
        -3659.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4076.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4480.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4118.0,
        -4480.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3659.999755859375,
      "bbox_min": [
        -3659.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4118.0,
        -4480.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4480.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4472.7685546875,
        1022.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4118.0,
        -4472.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1032.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872271299362183,
        -0.7264425754547119,
        -0.0
      ],
      "plane_d": -5683.5087890625,
      "bbox_min": [
        -3577.088134765625,
        -4454.267578125,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1032.5836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4118.0,
        -4472.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4439.7685546875,
        1032.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4472.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4439.7685546875,
        1032.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4086.999755859375,
      "bbox_min": [
        -4086.999755859375,
        -4449.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4439.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4108.0,
        -4499.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4489.7685546875,
        1032.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4489.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4488.107421875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872289776802063,
        0.726440966129303,
        0.0
      ],
      "plane_d": 825.793212890625,
      "bbox_min": [
        -4108.0,
        -4539.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4108.0,
        -4539.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9278250336647034,
        -0.37301579117774963,
        -0.0
      ],
      "plane_d": -4985.60107421875,
      "bbox_min": [
        -3564.375,
        -4506.26953125,
        1015.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1032.5826416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4108.0,
        -4539.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4499.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -4164.0,
        -4439.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3577.087890625,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4086.999755859375,
      "bbox_min": [
        -4164.0,
        -4399.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3588.8857421875,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.623779296875,
      "bbox_min": [
        -4086.999755859375,
        -3902.7685546875,
        1027.623779296875
      ],
      "bbox_max": [
        -4077.0,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3881.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -3902.7685546875,
        1027.623779296875
      ],
      "bbox_max": [
        -4077.0,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3902.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -3902.7685546875,
        1027.623779296875
      ],
      "bbox_max": [
        -4077.0,
        -3902.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6876122951507568,
        -0.7260780930519104,
        0.0
      ],
      "plane_d": -5683.3466796875,
      "bbox_min": [
        -3728.17138671875,
        -4337.68212890625,
        1027.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4296.7978515625,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3632.999755859375,
        -4330.6533203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4321.85595703125,
        1032.5880126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4330.65283203125,
        1027.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4321.85595703125,
        1032.5880126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4144425392150879,
        -0.9100755453109741,
        -0.0
      ],
      "plane_d": -5421.30859375,
      "bbox_min": [
        -4086.999755859375,
        -4341.24755859375,
        1015.623779296875
      ],
      "bbox_max": [
        -3588.8857421875,
        -3881.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4077.0,
      "bbox_min": [
        -4086.999755859375,
        -3902.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4077.0,
        -3881.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3881.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -3902.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4077.0,
        -3881.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3902.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -3902.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4077.0,
        -3902.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6876122951507568,
        -0.7260780930519104,
        0.0
      ],
      "plane_d": -5683.3466796875,
      "bbox_min": [
        -3728.17138671875,
        -4341.24755859375,
        1015.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4296.7978515625,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3926.568359375,
      "bbox_min": [
        -3675.999755859375,
        -4341.24755859375,
        1015.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4323.15283203125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4341.24755859375,
        1015.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4323.15283203125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4341.24755859375,
        1015.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4326.23876953125,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4086.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4222.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4342.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4112.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4122.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4002.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4012.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4012.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4076.999755859375,
        -4012.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4122.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4122.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4112.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4076.999755859375,
        -4122.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4112.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4332.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4342.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4222.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4232.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4232.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4222.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4076.999755859375,
        -4232.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4222.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4342.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4342.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4332.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4076.999755859375,
        -4342.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4332.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4164.0,
        -4399.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4112.7685546875,
      "bbox_min": [
        -4118.0,
        -4122.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4002.7685546875,
      "bbox_min": [
        -4118.0,
        -4012.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.7685546875,
      "bbox_min": [
        -4118.0,
        -4012.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4012.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4002.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4122.7685546875,
      "bbox_min": [
        -4118.0,
        -4122.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4112.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4122.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4112.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4332.7685546875,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4222.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4232.7685546875,
      "bbox_min": [
        -4118.0,
        -4232.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4222.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4232.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4222.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4342.7685546875,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4332.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4332.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3881.7685546875,
      "bbox_min": [
        -4164.0,
        -3902.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4164.0,
      "bbox_min": [
        -4164.0,
        -3902.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4164.0,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.623779296875,
      "bbox_min": [
        -4108.0,
        -3902.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3881.7685546875,
      "bbox_min": [
        -4108.0,
        -3881.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -3881.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872271299362183,
        -0.7264425754547119,
        -0.0
      ],
      "plane_d": -5683.5087890625,
      "bbox_min": [
        -4108.0,
        -4439.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3577.087890625,
        -4399.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.623779296875,
      "bbox_min": [
        -3619.3701171875,
        -4401.06494140625,
        1027.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4399.7685546875,
        1027.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4108.0,
        -4439.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4108.0,
        -4439.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4399.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4399.7685546875,
      "bbox_min": [
        -4164.0,
        -4810.24072265625,
        982.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -3881.7685546875,
        1015.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.4144425392150879,
        -0.9100755453109741,
        -0.0
      ],
      "plane_d": -5421.30859375,
      "bbox_min": [
        -3728.171142578125,
        -4342.21875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3588.8857421875,
        -4289.7998046875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6876122951507568,
        -0.7260780930519104,
        0.0
      ],
      "plane_d": -5683.3466796875,
      "bbox_min": [
        -3728.171142578125,
        -4342.21875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3632.999755859375,
        -4296.7978515625,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4342.21875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3632.999755859375,
        -4339.48193359375,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4086.999755859375,
      "bbox_min": [
        -4164.0,
        -4399.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3588.8857421875,
        -3881.7685546875,
        1015.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3902.7685546875,
      "bbox_min": [
        -4087.0,
        -4012.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -3881.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4012.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4012.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3881.7685546875,
      "bbox_min": [
        -4087.0,
        -3881.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4077.0,
        -3881.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7496428489685059,
        0.6618426442146301
      ],
      "plane_d": -3920.946044921875,
      "bbox_min": [
        -3675.999755859375,
        -4342.21875,
        1012.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4333.74755859375,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3632.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4342.21875,
        1012.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4336.8330078125,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4086.999755859375,
        -4399.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4122.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4342.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4342.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4332.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4076.999755859375,
        -4342.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4332.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4122.7685546875,
      "bbox_min": [
        -4086.999755859375,
        -4122.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4122.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4164.0,
        -4399.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -3881.7685546875,
        1015.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4342.7685546875,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4332.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4342.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4332.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.7685546875,
      "bbox_min": [
        -4118.0,
        -4122.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4002.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4122.7685546875,
      "bbox_min": [
        -4118.0,
        -4122.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4122.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4012.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4002.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3881.7685546875,
      "bbox_min": [
        -4164.0,
        -3881.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -3881.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3881.7685546875,
      "bbox_min": [
        -4108.0,
        -3881.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -3881.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4539.7685546875,
      "bbox_min": [
        -4128.0,
        -4810.24072265625,
        982.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4399.7685546875,
        1015.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -4128.0,
        -4810.24072265625,
        1002.5999755859375
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1015.6239013671875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.3026682138442993,
        0.9530960321426392,
        0.0
      ],
      "plane_d": 3348.042236328125,
      "bbox_min": [
        -3735.24462890625,
        -4675.39990234375,
        1002.5999755859375
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872249841690063,
        0.726444661617279,
        0.0
      ],
      "plane_d": 825.824951171875,
      "bbox_min": [
        -3735.24462890625,
        -4670.3876953125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1012.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3617.999755859375,
      "bbox_min": [
        -3632.999755859375,
        -4626.73486328125,
        1002.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4559.47216796875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4626.73486328125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3632.999755859375,
        -4624.5185546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4086.999755859375,
      "bbox_min": [
        -4128.0,
        -4810.24072265625,
        1012.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3026682138442993,
        0.9530960321426392,
        0.0
      ],
      "plane_d": 3348.042236328125,
      "bbox_min": [
        -4087.0,
        -4810.24072265625,
        1012.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": -5411.44384765625,
      "bbox_min": [
        -3892.340087890625,
        -4810.24072265625,
        1012.6239013671875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4748.87060546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933534979820251,
        -0.6087612509727478,
        0.0
      ],
      "plane_d": -5978.9296875,
      "bbox_min": [
        -3892.340087890625,
        -4754.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3887.814208984375,
        -4748.87060546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872249841690063,
        0.726444661617279,
        0.0
      ],
      "plane_d": 825.824951171875,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4539.7685546875,
        1015.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7406286001205444,
        0.6719146966934204,
        0.0
      ],
      "plane_d": 468.054931640625,
      "bbox_min": [
        -3675.999755859375,
        -4652.5048828125,
        1012.623779296875
      ],
      "bbox_max": [
        -3543.705810546875,
        -4559.47216796875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3617.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4632.95068359375,
        1012.623779296875
      ],
      "bbox_max": [
        -3617.999755859375,
        -4559.47216796875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4632.95068359375,
        1012.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8134896159172058,
        0.5815794467926025
      ],
      "plane_d": 3171.9716796875,
      "bbox_min": [
        -3632.999755859375,
        -4628.87939453125,
        1012.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3632.99951171875,
      "bbox_min": [
        -3632.999755859375,
        -4628.87939453125,
        1012.623779296875
      ],
      "bbox_max": [
        -3632.999755859375,
        -4624.5185546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826834261417389,
        -0.9238795042037964,
        0.0
      ],
      "plane_d": -5835.07470703125,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4539.7685546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4549.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4539.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052940368652344,
        0.9914445281028748,
        -0.0
      ],
      "plane_d": 5153.3759765625,
      "bbox_min": [
        -4087.0,
        -4748.87060546875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3892.340087890625,
        -4659.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826824724674225,
        0.9238799810409546,
        -0.0
      ],
      "plane_d": 5854.90185546875,
      "bbox_min": [
        -4032.64794921875,
        -4748.87060546875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3892.340087890625,
        -4666.9248046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933534979820251,
        -0.6087612509727478,
        0.0
      ],
      "plane_d": -5978.9296875,
      "bbox_min": [
        -3919.14404296875,
        -4748.87060546875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3892.340087890625,
        -4713.93896484375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933534979820251,
        -0.6087612509727478,
        0.0
      ],
      "plane_d": -5978.9296875,
      "bbox_min": [
        -3924.365478515625,
        -4713.93896484375,
        1012.6239013671875
      ],
      "bbox_max": [
        -3919.14404296875,
        -4707.13427734375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4128.0,
        -4659.76904296875,
        1012.623779296875
      ],
      "bbox_max": [
        -4087.0,
        -4539.7685546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4659.76904296875,
      "bbox_min": [
        -4128.0,
        -4659.76904296875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4639.7685546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4128.0,
      "bbox_min": [
        -4128.0,
        -4659.76904296875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4639.7685546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.441406286379788e-05,
        -1.0,
        0.0
      ],
      "plane_d": -4639.66845703125,
      "bbox_min": [
        -4128.0,
        -4639.76904296875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4639.7685546875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4659.76904296875,
      "bbox_min": [
        -4108.0,
        -4659.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -4087.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.7685546875,
      "bbox_min": [
        -4118.0,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -4118.0,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4488.107421875,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4472.7685546875,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": 1131.5269775390625,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        982.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4472.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4480.7685546875,
      "bbox_min": [
        -3784.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3659.999755859375,
      "bbox_min": [
        -3659.999755859375,
        -4488.107421875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4480.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3659.999755859375,
      "bbox_min": [
        -3659.999755859375,
        -4480.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3659.999755859375,
        -4472.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -4118.0,
        -4472.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4118.0,
        -4472.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4472.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 4107.99951171875,
      "bbox_min": [
        -4108.0,
        -4449.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4086.999755859375,
      "bbox_min": [
        -4086.999755859375,
        -4449.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4472.7685546875,
        1002.5999755859375
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872271299362183,
        -0.7264425754547119,
        -0.0
      ],
      "plane_d": -5683.5087890625,
      "bbox_min": [
        -3577.088134765625,
        -4454.267578125,
        1002.5999755859375
      ],
      "bbox_max": [
        -3561.76171875,
        -4439.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4489.7685546875,
      "bbox_min": [
        -4118.0,
        -4499.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4108.0,
        -4499.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4489.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -4086.99951171875,
      "bbox_min": [
        -4086.999755859375,
        -4499.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4086.999755859375,
        -4489.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -4076.999755859375,
      "bbox_min": [
        -4118.0,
        -4489.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4076.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4118.0,
      "bbox_min": [
        -4118.0,
        -4489.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4118.0,
        -4488.107421875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9278250336647034,
        -0.37301579117774963,
        -0.0
      ],
      "plane_d": -4985.60107421875,
      "bbox_min": [
        -3784.999755859375,
        -4499.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3564.375,
        -4488.107421875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4499.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4488.107421875,
        1015.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -4108.0,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1015.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": 1131.5269775390625,
      "bbox_min": [
        -3886.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -982.623779296875,
      "bbox_min": [
        -3836.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1012.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6872289776802063,
        0.726440966129303,
        0.0
      ],
      "plane_d": 825.793212890625,
      "bbox_min": [
        -3784.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4539.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1012.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3742.999755859375,
      "bbox_min": [
        -3742.999755859375,
        -4539.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3742.999755859375,
      "bbox_min": [
        -3742.999755859375,
        -4539.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4499.7685546875,
        1000.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872289776802063,
        0.726440966129303,
        0.0
      ],
      "plane_d": 825.793212890625,
      "bbox_min": [
        -4108.0,
        -4539.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4108.0,
        -4539.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9278250336647034,
        -0.37301579117774963,
        -0.0
      ],
      "plane_d": -4985.60107421875,
      "bbox_min": [
        -3564.375,
        -4506.26953125,
        1012.623779296875
      ],
      "bbox_max": [
        -3561.761474609375,
        -4499.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4108.0,
        -4539.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4499.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -4108.0,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3577.087890625,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": 1131.5269775390625,
      "bbox_min": [
        -3886.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3577.087890625,
        -4399.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -982.623779296875,
      "bbox_min": [
        -3836.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3577.087890625,
        -4399.7685546875,
        1012.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6872271299362183,
        -0.7264425754547119,
        -0.0
      ],
      "plane_d": -5683.5087890625,
      "bbox_min": [
        -3784.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3577.087890625,
        -4399.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4439.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1012.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3742.999755859375,
      "bbox_min": [
        -3742.999755859375,
        -4439.7685546875,
        1000.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1002.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3742.999755859375,
      "bbox_min": [
        -3742.999755859375,
        -4439.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3742.999755859375,
        -4399.7685546875,
        1000.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872271299362183,
        -0.7264425754547119,
        -0.0
      ],
      "plane_d": -5683.5087890625,
      "bbox_min": [
        -4108.0,
        -4439.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3577.087890625,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3784.999755859375,
      "bbox_min": [
        -4108.0,
        -4439.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -3784.999755859375,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4108.0,
        -4439.7685546875,
        1012.623779296875
      ],
      "bbox_max": [
        -4108.0,
        -4399.7685546875,
        1015.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: ring1a",
      "entity_class": "CSlidingDoor",
      "piece_name": "ring1a",
      "offset": 158122,
      "centroid": [
        -4097.4908203125,
        -4598.5,
        1022.623828125
      ],
      "bbox_min": [
        -4107.9501953125,
        -4600.0,
        1012.623779296875
      ],
      "bbox_max": [
        -4087.021484375,
        -4597.0,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 20.9287109375,
        "span_y": 3.0,
        "height_z": 20.0,
        "door_width": 20.9287109375,
        "door_depth": 3.0,
        "leaf_depth": 2.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -4097.5107421875,
          -4597.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4597.0,
          1027.6240234375
        ],
        [
          -4087.021484375,
          -4597.0,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -4597.0,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1017.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1027.623779296875
        ],
        [
          -4097.5107421875,
          -4600.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4600.0,
          1027.6240234375
        ],
        [
          -4087.021484375,
          -4600.0,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -4600.0,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -4600.0,
          1017.623779296875
        ],
        [
          -4107.9501953125,
          -4600.0,
          1027.623779296875
        ],
        [
          -4107.9501953125,
          -4600.0,
          1032.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4597.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4600.0,
          1032.623779296875
        ],
        [
          -4107.9501953125,
          -4600.0,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1012.623779296875
        ],
        [
          -4087.021484375,
          -4597.0,
          1012.623779296875
        ],
        [
          -4087.021484375,
          -4600.0,
          1012.623779296875
        ]
      ],
      "plane_distance": -4107.9502
    },
    {
      "tag": "CSlidingDoor piece: ring2a",
      "entity_class": "CSlidingDoor",
      "piece_name": "ring2a",
      "offset": 161048,
      "centroid": [
        -4097.4908203125,
        -4595.5,
        1022.623828125
      ],
      "bbox_min": [
        -4107.9501953125,
        -4597.0,
        1012.623779296875
      ],
      "bbox_max": [
        -4087.021484375,
        -4594.0,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 20.9287109375,
        "span_y": 3.0,
        "height_z": 20.0,
        "door_width": 20.9287109375,
        "door_depth": 3.0,
        "leaf_depth": 2.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -4097.5107421875,
          -4594.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4594.0,
          1027.6240234375
        ],
        [
          -4087.021484375,
          -4594.0,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -4594.0,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -4594.0,
          1017.623779296875
        ],
        [
          -4107.9501953125,
          -4594.0,
          1027.623779296875
        ],
        [
          -4097.5107421875,
          -4597.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4597.0,
          1027.6240234375
        ],
        [
          -4087.021484375,
          -4597.0,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -4597.0,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1017.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1027.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1032.623779296875
        ],
        [
          -4107.9501953125,
          -4594.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4594.0,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -4597.0,
          1032.623779296875
        ],
        [
          -4107.9501953125,
          -4597.0,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -4594.0,
          1012.623779296875
        ],
        [
          -4087.021484375,
          -4594.0,
          1012.623779296875
        ],
        [
          -4087.021484375,
          -4597.0,
          1012.623779296875
        ]
      ],
      "plane_distance": -4107.9502
    },
    {
      "tag": "CSlidingDoor piece: ring3a",
      "entity_class": "CSlidingDoor",
      "piece_name": "ring3a",
      "offset": 164016,
      "centroid": [
        -4097.4908203125,
        -3956.375,
        1022.623828125
      ],
      "bbox_min": [
        -4107.9501953125,
        -3957.875,
        1012.623779296875
      ],
      "bbox_max": [
        -4087.021484375,
        -3954.875,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 20.9287109375,
        "span_y": 3.0,
        "height_z": 20.0,
        "door_width": 20.9287109375,
        "door_depth": 3.0,
        "leaf_depth": 2.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -4097.5107421875,
          -3954.875,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -3954.875,
          1027.6240234375
        ],
        [
          -4087.021484375,
          -3954.875,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -3954.875,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -3954.875,
          1017.623779296875
        ],
        [
          -4107.9501953125,
          -3954.875,
          1027.623779296875
        ],
        [
          -4097.5107421875,
          -3957.875,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -3957.875,
          1027.6240234375
        ],
        [
          -4087.021484375,
          -3957.875,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -3957.875,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -3957.875,
          1017.623779296875
        ],
        [
          -4107.9501953125,
          -3957.875,
          1027.623779296875
        ],
        [
          -4107.9501953125,
          -3957.875,
          1032.623779296875
        ],
        [
          -4107.9501953125,
          -3954.875,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -3954.875,
          1032.623779296875
        ],
        [
          -4087.021484375,
          -3957.875,
          1032.623779296875
        ],
        [
          -4107.9501953125,
          -3957.875,
          1012.623779296875
        ],
        [
          -4107.9501953125,
          -3954.875,
          1012.623779296875
        ],
        [
          -4087.021484375,
          -3954.875,
          1012.623779296875
        ],
        [
          -4087.021484375,
          -3957.875,
          1012.623779296875
        ]
      ],
      "plane_distance": -4107.9502
    },
    {
      "tag": "CSlidingDoor piece: field1",
      "entity_class": "CSlidingDoor",
      "piece_name": "field1",
      "offset": 166942,
      "centroid": [
        -4097.510660807292,
        -4598.5,
        1022.6238606770834
      ],
      "bbox_min": [
        -4108.0107421875,
        -4598.5,
        1012.623779296875
      ],
      "bbox_max": [
        -4087.010498046875,
        -4598.5,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 21.000244140625,
        "span_y": 0.0,
        "height_z": 20.0,
        "door_width": 21.000244140625,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x"
      },
      "vertices": [
        [
          -4097.5107421875,
          -4598.5,
          1032.623779296875
        ],
        [
          -4087.010498046875,
          -4598.5,
          1027.6240234375
        ],
        [
          -4087.010498046875,
          -4598.5,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -4598.5,
          1012.623779296875
        ],
        [
          -4108.0107421875,
          -4598.5,
          1017.623779296875
        ],
        [
          -4108.0107421875,
          -4598.5,
          1027.623779296875
        ]
      ]
    },
    {
      "tag": "CSlidingDoor piece: field2",
      "entity_class": "CSlidingDoor",
      "piece_name": "field2",
      "offset": 191712,
      "centroid": [
        -4097.510660807292,
        -4594.81103515625,
        1022.6238606770834
      ],
      "bbox_min": [
        -4108.0107421875,
        -4594.81103515625,
        1012.623779296875
      ],
      "bbox_max": [
        -4087.010498046875,
        -4594.81103515625,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 21.000244140625,
        "span_y": 0.0,
        "height_z": 20.0,
        "door_width": 21.000244140625,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x"
      },
      "vertices": [
        [
          -4097.5107421875,
          -4594.81103515625,
          1032.623779296875
        ],
        [
          -4087.010498046875,
          -4594.81103515625,
          1027.6240234375
        ],
        [
          -4087.010498046875,
          -4594.81103515625,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -4594.81103515625,
          1012.623779296875
        ],
        [
          -4108.0107421875,
          -4594.81103515625,
          1017.623779296875
        ],
        [
          -4108.0107421875,
          -4594.81103515625,
          1027.623779296875
        ]
      ]
    },
    {
      "tag": "CSlidingDoor piece: field3",
      "entity_class": "CSlidingDoor",
      "piece_name": "field3",
      "offset": 222466,
      "centroid": [
        -4097.510660807292,
        -3956.375,
        1022.6238606770834
      ],
      "bbox_min": [
        -4108.0107421875,
        -3956.375,
        1012.623779296875
      ],
      "bbox_max": [
        -4087.010498046875,
        -3956.375,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 21.000244140625,
        "span_y": 0.0,
        "height_z": 20.0,
        "door_width": 21.000244140625,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x"
      },
      "vertices": [
        [
          -4097.5107421875,
          -3956.375,
          1032.623779296875
        ],
        [
          -4087.010498046875,
          -3956.375,
          1027.6240234375
        ],
        [
          -4087.010498046875,
          -3956.375,
          1017.6240234375
        ],
        [
          -4097.5107421875,
          -3956.375,
          1012.623779296875
        ],
        [
          -4108.0107421875,
          -3956.375,
          1017.623779296875
        ],
        [
          -4108.0107421875,
          -3956.375,
          1027.623779296875
        ]
      ]
    }
  ],
  "tutorial_messages": []
}